<template>
  <div class="company-info-container">
    <table class="info-container">
      <tr>
        <td width="50%">
          <img src="../assets/images/footer_product_name.png" width="200" style="margin-bottom: 16px">
          <div style="color: white; padding-left: 14px; padding-right: 44px">
            以系统医学为核心理论 为90%的缺乏医疗知识的人群提供在线医学人工智能症状分析、非处方药购买的一站式全程自我医疗解决方案
          </div>
        </td>
        <td>
          <div style="color: white; font-size: 16px; padding-left: 14px; padding-right: 44px">
            <div style="font-size: 17px; margin-bottom: 20px">联系我们</div>
            <p style="margin-bottom: 8px">公司：共创绿洲（贵州）医疗系统技术有限公司</p>
            <p style="margin-bottom: 8px">地址：贵阳市乌当区贵州省大健康医药产业智汇云锦孵化基地B2栋</p>
            <p>电话：400-0602-666</p>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'AppFooterCompanyInfo',
  data () {
    return {}
  },
  computed: {
    userName: function () {
      return ''
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    doSomething () {
    }
  }
}
</script>

<style scoped>
  .company-info-container {
    background-color: #424855;
    margin: 0 auto;
    position: relative;
    font-size: 16px;
  }

  @media only screen and (min-width: 992px) {
    .company-info-container {
      width: 992px;
    }
  }

  @media only screen and (min-width: 1200px) {
    .company-info-container {
      width: 1200px;
    }
  }
  .info-container {
    width: 100%;
    height: 230px;
    /*border: 1px solid white;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/AppFooterCompanyInfo.vue